import { ResourceOptions } from 'react-admin';
import { FaUserSlash } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.blindBoxBannedUsers;
export const icon = FaUserSlash;
export const options: ResourceOptions = {
  label: 'module.blindBox.banTitle',
};
